﻿import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from "../../../environments/environment";

import 'rxjs/add/operator/toPromise';

@Injectable()
export class DataService {
    public _baseUri: string;

    private headers = new HttpHeaders({ "Content-Type": "application/json" });
    private headersOctet = new HttpHeaders({ "Content-Type": "application/octet-stream" });

    constructor(private http: HttpClient) { }

    //#region Header
    /**
    * Agrega al header Content-Type -> application/x-www-form-urlencoded
    */
    // private addHeaderUrlencoded(): any {
    //     let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    //     let options = new RequestOptions({ headers: headers });

    //     return options;
    // }

    /**
    * Agrega al header Content-Type -> application/json
    */
    // private addHeaderJson(): any {
    //     let headers = new Headers({ "Content-Type": "application/json" });
    //     //let options = new RequestOptions({ headers: headers });

    //     return options;
    // }
    //#endregion

    //#region Token
    // private addHeaderToken(): any {
    //     let currentToken = localStorage.getItem('currenToken');

    //     if (currentToken == '')
    //         currentToken = this.getTokenLocalStorage();

    //     const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
    //     headers.append('Authorization', 'Bearer ' + currentToken);
    //     const options = new RequestOptions({ headers: headers });

    //     return options;
    // }

    // private getTokenLocalStorage(): string {
    //     localStorage.setItem('currenToken', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJub3ZpdCIsImp0aSI6IjBiOTQ4NjE3LWRhYWItNGY2YS1iYzRiLTM0ZGY4NmY3NmI0ZiIsImlhdCI6MTQ5OTQ1NjEyNywibmJmIjoxNDk5NDU2MTI3LCJleHAiOjE0OTk0NTk3MjcsImlzcyI6IkV4YW1wbGVJc3N1ZXIiLCJhdWQiOiJFeGFtcGxlQXVkaWVuY2UifQ.Cd4rcCdpnecwO_yVx2uuul7KodVI4so2ENYgqeXHnVE');
    //     let currentToken = localStorage.getItem('currenToken');
    //     return currentToken;
    // }
    //#endregion

    //#region Methods
    set(baseUri: string, pageSize?: number): void {
        this._baseUri = environment.serviceUrl + baseUri;
    }

    /**
    *Ejecuta el metodo post, enviando como cabecera el Json
    */
    execPostJson(data?: any): any {
        return this.http.post(this._baseUri, data, { headers: this.headers });
    }

    execPostJsonHeader(data: any, headers: any): any {
      return this.http.post(this._baseUri, data, { headers: headers });
  }

    execGetJson(data?: any): any {
        return this.http.get(this._baseUri, { params: data, headers: this.headers });
    }

    execGetOctet(data?: any): any {
        return this.http.get(this._baseUri, { params: data, headers: this.headersOctet, responseType: "blob" });
    }

    execPutJson(data?: any): any {
        return this.http.put(this._baseUri, data, { headers: this.headers });
    }

    execDeleteJson(data?: any): any {
        return this.http.delete(this._baseUri, { headers: this.headers, params: data })
    }

    /**
    *Ejecuta el metodo post, enviando como cabecera el Urlencoded
    */
    // execPostUrlencoded(data?: any, mapJson: boolean = true): any {
    //     this.headers = this.addHeaderJson();
    //     if (mapJson) {
    //         return this.http.post(this._baseUri, data, { headers: this.headers })
    //         .map(response => <any>(<Response>response));
    //     }
    //     else
    //         return this.http.post(this._baseUri, data, { headers: this.headers });
    // }

    /**
    *Ejecuta el metodo get, enviando como cabecera el Json
    */
    /*
    execGetJson(searchCriteria?: any) {
        this.headers = this.addHeaderJson();
        if (searchCriteria != null)
            return this.http.get(this._baseUri, { search: searchCriteria, headers: this.headers })
        .map(response => (<Response>response));
        else
            return this.http.get(this._baseUri, { headers: this.headers })
        .map(response => (<Response>response));
    }
    */

    /**
    * @param {string} url url del servicio a utilizar.
    * @param {URLSearchParams} parameters parametros a enviar al servicio.
    **/
    /*
    execPostUrlencoded(url: string, parameters: URLSearchParams): Promise<any> {
        let data: Observable<any[]>;
        let options = this.addHeaderUrlencoded();

        return this.http.post(url, parameters.toString(), options)
        .toPromise()
        .then(this.extractData)
        .catch(this.handleError);
    }
    */

    /**
    * Extrae información del objeto response y lo devuelve en formato json
    * @param res
    */
    // public extractData(res: Response) {
    //     const body = res.json();
    //     return body || {};
    // }

    /**
    * Obtiene el mensaje de error y lo devuelve
    * @param error
    */
    // public handleError(error: any): Promise<any> {
    //     // console.log('An error occurred', error);
    //     return Promise.reject(error.message || error);
    // }
    //#endregion
}
